// extracted by mini-css-extract-plugin
module.exports =  {"list":"GroupChooser-hIXs__list","active":"GroupChooser-B0bq__active","is-favorite":"GroupChooser-cpQd__is-favorite"};